<template>
    <div class="main-cnt ex-has-btm" style="padding: 20px 10px 0px 10px">
        <div class="block-cnt">
            <div class="content-wallet">
                    <!-- タブメニュー -->
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active': screenType == constants.BeforeContractScreenType}"
                                @click="switchScreen(constants.BeforeContractScreenType)">
                                <i class="icon-before-contract-red mr-2"></i>
                                {{$t('tab.before_handjob')}}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active': screenType == constants.AfterContractScreenType}"
                                @click="switchScreen(constants.AfterContractScreenType)">
                                <i class="icon-change-contract-red mr-2"></i>
                                {{$t('tab.after_handjob')}}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active': screenType == constants.ConfirmContractScreenType}"
                                @click="switchScreen(constants.ConfirmContractScreenType)">
                                <i class="icon-confirm-contract-red mr-2"></i>
                                {{$t('tab.confirm')}}
                            </a>
                        </li>
                    </ul>
            </div>

            <tour-info></tour-info>

            <div class="heading-breadcrumb">
                <p v-show="screenType == constants.BeforeContractScreenType">証憑明細登録 > 契約書 > 旅行契約(契約書類)</p>
                <p v-show="screenType == constants.AfterContractScreenType">証憑明細登録 > 契約書 > 旅行契約(変更書類)</p>
                <p v-show="screenType == constants.ConfirmContractScreenType">証憑明細登録 > 契約書 > 旅行契約(確定書類)</p>
            </div>

            <div class="content-wallet">
                <div v-show="screenType == constants.BeforeContractScreenType">
                    <!-- 一括取込 -->
                    <div class="table-static"  v-show="isBulkShow">
                        <div class="summary-contract" @click="openToggle(1)">
                            旅行条件書・旅程表・内訳書 一括取込<i :class="isBulkOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i>
                            <div class="sub-title">※複合機で1ファイルにしている場合はこちら</div>
                        </div>
                        <transition name="bulk">
                            <div class="toggle" v-show="isBulkOpened">
                                <div class="contract-sub-head">旅行条件書・旅程表・内訳書一括<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_bulk.id, bulk ? bulk.id : '')"></i></div>
                                <div class="sub-cnt">
                                    <div class="no-data" v-if="utils.isEmptyObj(bulk)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="bulk" @detail="detailContract(bulk.id)"></contract-row>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <div class="table-static" v-show="isAloneShow">
                        <div class="summary-contract" @click="openToggle(2)">旅行条件書・旅程表・内訳書 個別取込<i :class="isAloneOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i></div>
                        <transition name="alone">
                        <div v-show="isAloneOpened">
                            <div class="sub-cnt">
                                <div class="head">旅行条件書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_conditions.id, condition ? condition.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(condition)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="condition" @detail="detailContract(condition.id)"></contract-row>
                            </div>

                            <div class="sub-cnt">
                                <div class="head">旅行日程表<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_schedule.id, schedule ? schedule.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(schedule)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="schedule" @detail="detailContract(schedule.id)"></contract-row>
                            </div>

                            <div class="sub-cnt">
                                <div class="head">旅行内訳書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_items.id, item ? item.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(item)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="item" @detail="detailContract(item.id)"></contract-row>
                            </div>
                        </div>
                        </transition>
                    </div>

                    <!-- 旅行申込書 -->
                    <div class="table-static">
                        <div class="summary-contract">{{ $t('contract.before.travel_apply') }}<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.contract_travel.id, apply ? apply.id : '')"></i></div>
                        <div class="mrgn-l-10">
                            <div class="no-data" v-if="utils.isEmptyObj(apply)">{{ $t('contract.no_data') }}</div>
                            <contract-row v-else :contract="apply" @detail="detailContract(apply.id)"></contract-row>
                        </div>
                    </div>

                    <!-- 旅行引受書 -->
                    <div class="table-static">
                        <div class="summary-contract">{{ $t('contract.before.travel_underwriting') }}<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.contract_underwriting.id, under ? under.id : '')"></i></div>
                        <div class="mrgn-l-10">
                            <div class="no-data" v-if="utils.isEmptyObj(under)">{{ $t('contract.no_data') }}</div>
                            <contract-row v-else :contract="under" @detail="detailContract(under.id)"></contract-row>
                        </div>
                    </div>

                    <!-- パンフレット -->
                    <div class="table-static">
                        <div class="summary-contract">{{ $t('contract.before.travel_pamphlet') }}<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_pamphlet.id, pamphlet ? pamphlet.id : '')"></i></div>
                        <div class="mrgn-l-10">
                            <div class="no-data" v-if="utils.isEmptyObj(pamphlet)">{{ $t('contract.no_data') }}</div>
                            <contract-row v-else :contract="pamphlet" @detail="detailContract(pamphlet.id)"></contract-row>
                        </div>
                    </div>
                </div>

                <div v-show="screenType == constants.AfterContractScreenType">
                    <!-- 一括取込 -->
                    <div class="table-static" v-show="isBulkShow">
                        <div class="summary-contract" @click="openToggle(1)">
                            旅行条件書・旅程表・内訳書 一括取込<i :class="isBulkOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i>
                            <div class="sub-title">※複合機で1ファイルにしている場合はこちら</div>
                        </div>
                        <transition name="bulk">
                            <div class="toggle" v-show="isBulkOpened">
                                <div class="contract-sub-head">旅行条件書・旅程表・内訳書一括<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_bulk.id, bulk ? bulk.id : '')"></i></div>
                                <div class="sub-cnt">
                                    <div class="no-data" v-if="utils.isEmptyObj(bulk)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="bulk" @detail="detailContract(bulk.id)"></contract-row>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <div class="table-static" v-show="isAloneShow">
                        <div class="summary-contract" @click="openToggle(2)">旅行条件書・旅程表・内訳書 個別取込<i :class="isAloneOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i></div>
                        <transition name="alone">
                        <div v-show="isAloneOpened">
                            <div class="sub-cnt">
                                <div class="head">旅行条件書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_conditions.id, condition ? condition.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(condition)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="condition" @detail="detailContract(condition.id)"></contract-row>
                            </div>

                            <div class="sub-cnt">
                                <div class="head">旅行日程表<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_schedule.id, schedule ? schedule.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(schedule)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="schedule" @detail="detailContract(schedule.id)"></contract-row>
                            </div>

                            <div class="sub-cnt">
                                <div class="head">旅行内訳書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_items.id, item ? item.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(item)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="item" @detail="detailContract(item.id)"></contract-row>
                            </div>
                        </div>
                        </transition>
                    </div>
                </div>

                <div v-show="screenType == constants.ConfirmContractScreenType">
                    <!-- 一括取込 -->
                    <div class="table-static" v-show="isBulkShow">
                        <div class="summary-contract" @click="openToggle(1)">
                            旅行条件書・旅程表・内訳書 一括取込<i :class="isBulkOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i>
                            <div class="sub-title">※複合機で1ファイルにしている場合はこちら</div>
                        </div>
                        <transition name="bulk">
                            <div class="toggle" v-show="isBulkOpened">
                                <div class="contract-sub-head">旅行条件書・旅程表・内訳書一括<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_bulk.id, bulk ? bulk.id : '')"></i></div>
                                <div class="sub-cnt">
                                    <div class="no-data" v-if="utils.isEmptyObj(bulk)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="bulk" @detail="detailContract(bulk.id)"></contract-row>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <div class="table-static" v-show="isAloneShow">
                        <div class="summary-contract" @click="openToggle(2)">旅行条件書・旅程表・内訳書 個別取込<i :class="isAloneOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i></div>
                        <transition name="alone">
                        <div v-show="isAloneOpened">
                            <div class="sub-cnt">
                                <div class="head">旅行条件書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_conditions.id, condition ? condition.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(condition)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="condition" @detail="detailContract(condition.id)"></contract-row>
                            </div>

                            <div class="sub-cnt">
                                <div class="head">旅行日程表<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_schedule.id, schedule ? schedule.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(schedule)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="schedule" @detail="detailContract(schedule.id)"></contract-row>
                            </div>

                            <div class="sub-cnt">
                                <div class="head">旅行内訳書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_items.id, item ? item.id : '')"></i></div>
                                <div class="no-data" v-if="utils.isEmptyObj(item)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="item" @detail="detailContract(item.id)"></contract-row>
                            </div>
                        </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <input
            type="file"
            ref="inputUpload"
            name
            class="d-none"
            accept="image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"            multiple
            @change="preprocessUpload"
            style="display: none"
        />
        <SpCameraPreProcessingVoucher
            v-if="showPreprocessingUpload"
            :files.sync="files"
            :voucherType="voucherType"
            :filePath="filePath"
            @finish="finishUpload"
            @close="closePreprocessingUpload"
            @enableButton="$emit('enableButton', $event)"
            @update:actionHandler="$emit('update:actionHandler', $event)"
            @update:backHandler="$emit('update:backHandler', $event)"
            @update-filePath="changeFilePath"
        ></SpCameraPreProcessingVoucher>
    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

import StorageService from "@/services/common/storage.service";
import VoucherService from "@/services/module/voucher.service";
import { AuthService } from "@/services/common/auth.service";

import TourInfo from "@/views/components/sp/Tour/Info";
import SpCameraPreProcessingVoucher from "@/views/components/sp/Voucher/CameraPreProcessing";
import ContractRow from "@/views/components/common/ContractRow";

export default {
    components: {
        TourInfo,
        SpCameraPreProcessingVoucher,
        ContractRow,
    },
    name: "SpContracts",
    data() {
        return {
            constants: Constants,
            utils: Utils,
            dateUtils: DateUtils,
            renderSearchTour: true,
            groupType: Constants.GroupVoucherType.travel_contract,
            screenType: Constants.BeforeContractScreenType,
            tourInfo: "",
            contractId: "",
            files: "",
            uploadFiles: [],
            previewFileUpload: false,
            voucherType: "",
            errorMessage: "",
            num: 0,

            // 各契約書リスト・先頭アイテム
            condition: {},
            schedule: {},
            apply: {},
            under: {},
            item: {},
            pamphlet: {},
            bulk: {},

            modeAdd: false,
            voucher: {},
            voucherParams: {},
            ocrData: "",
            filePath: "",
            signature: false,

            showPreprocessingUpload: false,

            isBulkOpened: false,
            isAloneOpened: false,
            isBulkShow: true,
            isAloneShow: true,
        }
    },

    methods: {
        listVouchers () {
            this.reset();
            return VoucherService.contracts(this.screenType).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    const errCode = Utils.getErrorCode(response);
                    if (errCode) {
                        const msg = this.$root.$t("error.error_code_" + errCode);
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.formatContracts(response.data)
                    } else {
                        this.listVoucher = [];
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            }).catch(err => {
                this.errorMessage = this.$root.$t("error.error_unknown");
            });
        },

        // 契約証憑整形
        formatContracts (data) {
            this.apply = data.apply ? data.apply : {};
            this.under = data.under ? data.under : {};
            this.condition = data.condition;
            this.schedule = data.schedule;
            this.item = data.item;
            this.pamphlet = data.pamphlet;
            this.bulk = data.bulk;

            if (this.checkAloneContract()) {
                this.isAloneOpened = true;
                this.isBulkShow = false;
            } else if (!Utils.isEmptyObj(this.bulk)) {
                this.isBulkOpened = true;
                this.isAloneShow = false;
            }
        },

        // カメラアイコン
        setVoucherType (type, id = "") {
            this.reset();
            this.voucherType = type;
            if (!Utils.isEmptyStr(id)) {
                this.contractId = id;
            } else {
                this.contractId = "";
            }
            this.selectFiles();
        },
        selectFiles () {
            this.$refs.inputUpload.click();
        },
        preprocessUpload (e) {
            if (e.target.files.length > 10) {
                alert(this.$t('voucher.upload.max_file'));
                // turn on body scroll
                const el = document.body;
                el.classList.remove("over-hidden");
            } else {
                var files = [];
                for (let i = 0; i < e.target.files.length; i++) {
                    files.push(e.target.files[i]);
                }
                this.files = files;

                if (this.files.length != 0) {
                    if (this.isPdf(this.files)) {
                        this.getFormData().then(formD => {
                            return VoucherService.checkPwdPdf(formD);
                        }).then(response => {
                            if (response.status == 423) {
                                StorageService.saveExpired();
                                AuthService.doLogout();
                            } else if (response.status != 200) {
                                let errorCode = Utils.getErrorCode(response);
                                let msg = this.$root.$t("fail.add_fail");
                                if (errorCode) {
                                    msg = this.$root.$t("error.error_code_" + errorCode);
                                }
                                this.$toasted.error(msg, {});
                            } else {
                                let msg = this.$root.$t("success.add_success");
                                this.$toasted.success(msg, {});
                                this.showPreprocessingUpload = true;
                            }
                        });
                    } else {
                        let msg = this.$root.$t("success.add_success");
                        this.$toasted.success(msg, {});
                        this.showPreprocessingUpload = true;
                    }
                }
                // turn off body scroll
                const el = document.body;
                el.classList.add("over-hidden");
            }

            // Reset input file
            e.target.value = "";
        },
        isPdf(files) {
            for (let file of files) {
                if (file.type == 'application/pdf') {
                    return true;
                }
            }
            return false;
        },
        async getFormData() {
            let formData = new FormData();
            for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i];
                formData.append('files', file);
            }
            return formData;
        },
        changeFilePath (filePath) {
            this.filePath = filePath;
        },
        finishUpload (responseData) {
            const el = document.body;
            el.classList.remove("over-hidden");
            this.ocrData = responseData;
            this.signature = this.ocrData.signature;
            this.goToAddVoucher();
        },
        closePreprocessingUpload () {
            this.$emit("update:backHandler", () => {
                this.$router.go(-1);
            });
            this.$emit("enableButton");
            this.$emit("update:actionHandler", () => {});
            this.showPreprocessingUpload = false;

            // turn on body scroll
            const el = document.body;
            el.classList.remove("over-hidden");
        },

        goToAddVoucher () {
            this.$router.push({
                path: "/voucher/add",
                query: { screenType: "" },
            });
            this.voucherParams = {};
            if (!Utils.isEmptyStr(this.contractId)) {
                this.voucherParams.id = this.contractId;
            }
            this.voucherParams.voucherTypeId = this.voucherType;
            this.voucherParams.cashInOutType = this.screenType;
            this.voucherParams.cashId = this.cashId;
            let filePath = "";
            if (this.ocrData.path) {
                filePath = this.ocrData.path;
            }
            this.voucherParams.filePath = filePath;
            this.voucherParams.signature = this.signature;
            this.voucherParams.modeAdd = this.modeAdd;
            if (!Utils.isEmptyObj(this.ocrData.ocr) && !Utils.isEmptyObj(this.ocrData.ocr.mapping)) {
                let data = this.ocrData.ocr.mapping.template_mapping;
                if (data.transaction_date && data.transaction_date[0]) {
                    this.voucherParams.transactionDate = new Date(
                        data.transaction_date[0]
                    );
                }
            }
            StorageService.saveVoucher(JSON.stringify(this.voucherParams));
            StorageService.saveVoucherType(this.voucherTypeId);
        },

        detailContract (voucherId) {
            this.activeVoucher = voucherId;
            this.$router.push({
                path: "/voucher/detail",
                query: { voucherId: voucherId, screenType: "" },
            });
        },

        // タブ切り替え
        switchScreen (screenType) {
            this.allReset();
            this.screenType = screenType;
            this.listVouchers(this.screenType);
            this.$router.push({path: '/voucher/contracts', query:{ screenType: screenType }});
        },
        // 同一種別の複数取込時のアコーディオン表示

        reset () {
            this.errorMessage = "";
            this.voucherType = "";
            this.uploadFiles = [];
            this.previewFileUpload = false;
            this.num = 0;
            this.modeAdd = false;
        },
        allReset () {
            this.reset();

            this.condition = {};
            this.apply = {};
            this.under = {};
            this.schedule = {};
            this.item = {};
            this.pamphlet = {};
            this.bulk = {};
            this.contractId = "";
            this.isBulkOpened = false;
            this.isAloneOpened = false;
            this.isBulkShow = true;
            this.isAloneShow = true;
        },

        checkAloneContract() {
            return !Utils.isEmptyObj(this.condition) || !Utils.isEmptyObj(this.schedule) || !Utils.isEmptyObj(this.item);
        },

        openToggle(type) {
            if (type == 1) {
                this.isBulkOpened = !this.isBulkOpened;
                if (this.isBulkOpened) {
                    this.isAloneOpened = false;
                }
            } else {
                this.isAloneOpened = !this.isAloneOpened;
                if (this.isAloneOpened) {
                    this.isBulkOpened = false;
                }
            }
        },
    },

    beforeMount () {
        this.screenType = !Utils.isEmptyStr(this.$route.query.screenType) ? this.$route.query.screenType : 4;
        this.listVouchers();
    },
    watch: {
        $route (to, from) {
            if (!Utils.isEmptyStr(to.query.screenType) && !Utils.isEmptyStr(from.query.screenType) && to.query.screenType != from.query.screenType) {
                this.screenType = to.query.screenType;
                this.listVouchers();
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/Contracts.vue